import { required } from '@vuelidate/validators'

export const CreateTemplateValidation = {
    title: { required },
    full_name: { required },
    phone: { required },
    additional_phone: { required },
    //
    city_id: { required },
    full_address: { required },
    latitude: { required },
    longitude: { required },
}
